'use es6';

import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { CUSTOM_DASHBOARD_COUNT, CUSTOM_DASHBOARD_LIMIT, DASHBOARD_FETCH_FAILED, DASHBOARD_IS_LOADING, MAX_USER_ASSET_PERMISSION, USER_DASHBOARD_PERMISSION } from 'dashboard-lib/private/action-problem-solution/params/all-params';
import { getCloneDashboardProblem } from 'dashboard-lib/public/enable-action/clone-dashboard';
import { AssetPermission } from 'dashboard-lib/public/permission/asset-permission';
import { getUserPermissionLevel } from 'dashboard-lib/public/dashboard/dashboard-schema';
import { LOADING } from 'dashboard-lib/private/action-problem-solution/actions/clone-dashboard/problem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getDisabledProblemMessage } from '../disabled-message/actions/clone-dashboard';
import { DASHBOARD_CLONE } from 'dashboard-lib/public/action/reporting-action';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const CloneDashboardAction = props => {
  const {
    customDashboardCount,
    customDashboardLimit,
    customReportCount,
    customReportLimit,
    dashboard,
    dashboardFetchFailed = false,
    isDashboardFetched = false,
    maxUserAssetPermission,
    onClone,
    trackClick,
    trackAction,
    store,
    showDialog
  } = props;
  const getCloneProblem = useCallback(originalDashboard => getCloneDashboardProblem({
    [DASHBOARD_IS_LOADING]: !originalDashboard || !isDashboardFetched,
    [DASHBOARD_FETCH_FAILED]: dashboardFetchFailed,
    [USER_DASHBOARD_PERMISSION]: getUserPermissionLevel(dashboard),
    [MAX_USER_ASSET_PERMISSION]: maxUserAssetPermission,
    [CUSTOM_DASHBOARD_COUNT]: customDashboardCount,
    [CUSTOM_DASHBOARD_LIMIT]: customDashboardLimit
  }), [customDashboardCount, customDashboardLimit, dashboard, dashboardFetchFailed, isDashboardFetched, maxUserAssetPermission]);
  const handleCloneDashboardClick = useCallback(e => {
    e.preventDefault();
    showDialog({
      dialogType: DASHBOARD_CLONE,
      dialogProps: {
        customReportCount,
        customReportLimit,
        dashboard,
        getCloneWidgetsProblem: getCloneProblem,
        onClone,
        trackAction,
        store
      }
    });
    trackClick();
  }, [showDialog, customReportCount, customReportLimit, dashboard, getCloneProblem, onClone, trackClick, trackAction, store]);
  const problem = getCloneProblem(dashboard);
  const Message = getDisabledProblemMessage({}, problem);
  const buttonLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard-actions.cloneDashboard.name"
  });
  return /*#__PURE__*/_jsx(UITooltip, {
    title: Message && /*#__PURE__*/_jsx(Message, {}),
    disabled: !problem,
    placement: "left",
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": problem !== LOADING.toString() && 'dashboard-action-clone-dashboard',
      onClick: handleCloneDashboardClick,
      disabled: !!problem,
      use: "link",
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(View, {
          marginInlineEnd: "100",
          as: "span",
          children: buttonLabel
        })
      })
    })
  }, "clone");
};
CloneDashboardAction.propTypes = {
  customDashboardCount: PropTypes.number.isRequired,
  customDashboardLimit: PropTypes.number.isRequired,
  customReportCount: PropTypes.number.isRequired,
  customReportLimit: PropTypes.number.isRequired,
  dashboard: PropTypes.instanceOf(ImmutableMap).isRequired,
  isDashboardFetched: PropTypes.bool,
  dashboardFetchFailed: PropTypes.bool,
  maxUserAssetPermission: PropTypes.oneOf(Object.keys(AssetPermission)).isRequired,
  onClone: PropTypes.func.isRequired,
  trackClick: PropTypes.func.isRequired,
  trackAction: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired,
  showDialog: PropTypes.func.isRequired
};
export default CloneDashboardAction;